export { default } from './TextCopy';
